export default __webpack_public_path__ + "static/media/Foothills.6322d4ee.jpg";